var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.465 3H7.53504C6.68726 3 6 3.90721 6 5.02628V18.1337C6 19.2528 6.68726 20.16 7.53504 20.16H17.465C18.3127 20.16 19 19.2528 19 18.1337V5.02628C19 3.90721 18.3127 3 17.465 3Z",
    fill: "url(#paint0_linear_468_75988)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.893 5.07996H8.90698C8.73743 5.07996 8.59998 5.20023 8.59998 5.34859V7.08632C8.59998 7.23469 8.73743 7.35496 8.90698 7.35496H10.893C11.0625 7.35496 11.2 7.23469 11.2 7.08632V5.34859C11.2 5.20023 11.0625 5.07996 10.893 5.07996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.893 8.71997H8.90698C8.73743 8.71997 8.59998 8.84024 8.59998 8.98861V10.7263C8.59998 10.8747 8.73743 10.995 8.90698 10.995H10.893C11.0625 10.995 11.2 10.8747 11.2 10.7263V8.98861C11.2 8.84024 11.0625 8.71997 10.893 8.71997Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.893 12.36H8.90698C8.73743 12.36 8.59998 12.4803 8.59998 12.6286V14.3664C8.59998 14.5147 8.73743 14.635 8.90698 14.635H10.893C11.0625 14.635 11.2 14.5147 11.2 14.3664V12.6286C11.2 12.4803 11.0625 12.36 10.893 12.36Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.093 5.07996H14.107C13.9374 5.07996 13.8 5.20023 13.8 5.34859V7.08632C13.8 7.23469 13.9374 7.35496 14.107 7.35496H16.093C16.2625 7.35496 16.4 7.23469 16.4 7.08632V5.34859C16.4 5.20023 16.2625 5.07996 16.093 5.07996Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.093 8.71997H14.107C13.9374 8.71997 13.8 8.84024 13.8 8.98861V10.7263C13.8 10.8747 13.9374 10.995 14.107 10.995H16.093C16.2625 10.995 16.4 10.8747 16.4 10.7263V8.98861C16.4 8.84024 16.2625 8.71997 16.093 8.71997Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.093 12.36H14.107C13.9374 12.36 13.8 12.4803 13.8 12.6286V14.3664C13.8 14.5147 13.9374 14.635 14.107 14.635H16.093C16.2625 14.635 16.4 14.5147 16.4 14.3664V12.6286C16.4 12.4803 16.2625 12.36 16.093 12.36Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 17C10.42 16.4477 10.8677 16 11.42 16H13.58C14.1323 16 14.58 16.4477 14.58 17V20.16H10.42V17Z",
    fill: "url(#paint1_linear_468_75988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75988",
    x1: 7.93817,
    y1: 3.51469,
    x2: 20.0242,
    y2: 13.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18B7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185EF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75988",
    x1: 10.42,
    y1: 18.0801,
    x2: 14.58,
    y2: 18.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorBuilding);
export default __webpack_public_path__ + "static/media/color-building.06f9377e28a60fe4fff22ab30e730557.svg";
export { ForwardRef as ReactComponent };